import { ProfileStoreType } from "../DynamicProfileEnums";
import { DynamicProfileHubBase } from "../DynamicProfileHubBase";
import { DynamicCrossSectionMapStore } from "./DynamicCrossSectionMapStore";
import { DynamicCrossSectionProfileStore } from "./DynamicCrossSectionProfileStore";
import { DynamicCrossSectionTableStore } from "./DynamicCrossSectionTableStore";

class DynamicCrossSectionHub extends DynamicProfileHubBase {
    protected _profileStore: DynamicCrossSectionProfileStore | undefined;
    protected _profileStore1: DynamicCrossSectionProfileStore | undefined;
    protected _profileStore2: DynamicCrossSectionProfileStore | undefined;
    protected _profileStore3: DynamicCrossSectionProfileStore | undefined;
    protected _mapStore: DynamicCrossSectionMapStore | undefined;
    protected _tableStore: DynamicCrossSectionTableStore | undefined;

    constructor() {
        super();
    }

    public createStore(storeType: ProfileStoreType, option: any = void 0, threeCrossSection: boolean = false) {
        switch (storeType) {
            case ProfileStoreType.MAP:
                this._mapStore = new DynamicCrossSectionMapStore(this);
                this.MapStore!.MapView = option?.mapView;
                this.disposer.Track(this._mapStore);
                break;

            case ProfileStoreType.PROFILE:
                if (!threeCrossSection) {
                    this._profileStore = new DynamicCrossSectionProfileStore(this);
                    this.disposer.Track(this._profileStore);
                    break;
                } else {
                    this._profileStore1 = new DynamicCrossSectionProfileStore(this);
                    this._profileStore2 = new DynamicCrossSectionProfileStore(this);
                    this._profileStore3 = new DynamicCrossSectionProfileStore(this);
                    this.disposer.Track(this._profileStore1);
                    this.disposer.Track(this._profileStore2);
                    this.disposer.Track(this._profileStore3);
                    break;
                }

            case ProfileStoreType.TABLE:
                this._tableStore = new DynamicCrossSectionTableStore(this);
                this.disposer.Track(this._tableStore);
                break;

            default:
                break;
        }
    }

    /** for compatibility to existing code */
    private _setStore;
    set setStore(setStore) {
        this._setStore = setStore;
    }

    get setStore() {
        return this._setStore;
    }

    private _crossSectionStore;
    public get crossSectionStore() {
        return this._crossSectionStore;
    }
    public set crossSectionStore(value) {
        this._crossSectionStore = value;
    }

    public get crossSectionProfileStore(){
        return this._profileStore
    }

    public get crossSectionTableStore(){
        return this._tableStore
    }

}
export { DynamicCrossSectionHub } 